<nav class="navbar navbar-expand-lg navbar-light w-100 navigation" id="navbar" [ngClass]="{
  'overlay-content': !isSticky,
  'nav-opacity bg-white': isTransparentNavOnScroll && navBarType !== NAVBAR_TYPE_FLOATING,
  'bg-white': isMobile && navBarType !== NAVBAR_TYPE_FLOATING,
  'nav-opacity bg-white navbar-bg': navBarType !== NAVBAR_TYPE_TRANSPARENT && navBarType !== NAVBAR_TYPE_FLOATING,
  'sticky': isSticky
  }">
  <div [ngClass]="{
  'container': true,
  'nav-opacity bg-white navbar-bg': navBarType === NAVBAR_TYPE_FLOATING
  }">
    <a *ngIf="!withNavBarLogo" class="navbar-brand font-weight-bold nav-link" routerLink=""
      (click)="onClickInitHome()">{{ ownerDetail.company_name
      }}</a>
    <a *ngIf="withNavBarLogo" class="navbar-brand font-weight-bold nav-link" routerLink="" (click)="onClickInitHome()">
      <div class="logo-container">
        <img *ngIf="logoUrl==DF_LOGO" class="logo-img" src="{{logoUrl}}">
        <img *ngIf="logoUrl!=DF_LOGO" class="logo-img" [src]="logoUrl">
      </div>
    </a>
    <span *ngIf="envTag !== ''" class="env-tag">{{ envTag }}</span>

    <div *ngIf="isMobile" class="mobile-toggler-group d-flex align-items-center">
      <button *ngIf="langBtnType !== 'none'" class="navbar-toggler" type="button" (click)="openLanguageModal()">
        <i *ngIf="langBtnType === 'default'" class="tf-ion-ios-world"></i>
        <img *ngIf="langBtnType.startsWith('rounded-')" class="rounded-mobile-lang-icon-img"
          [src]="'assets/img/languages/' + getLangSelected() + '.webp'" alt="Lang">
        <img *ngIf="langBtnType.startsWith('square-')" class="square-mobile-lang-icon-img"
          [src]="'assets/img/languages/' + getLangSelected() + '.webp'" alt="Lang">
      </button>

      <button class="navbar-toggler" type="button" (click)="toggleMenu()" (mouseenter)="hoverIcon(true)"
        (mouseleave)="hoverIcon(false)" [attr.aria-expanded]="isMenuOpen" aria-controls="main-navbar"
        aria-label="Toggle navigation">

        <i [ngClass]="{
          'tf-ion-chevron-up': isMenuOpen,
          'tf-ion-chevron-down': isHovered && !isMenuOpen,
          'tf-ion-drag': !isMenuOpen && !isHovered
        }"></i>
      </button>
    </div>

    <div class="navbar-collapse {{navBarAlign !== 'center' ? 'nav-bar-align-' + navBarAlign : ''}}"
      [ngClass]="{'show': isMenuOpen}" id="main-navbar" #mainNavbar>
      <ul class="navbar-nav {{navBarAlign !== 'center' ? '' : 'mx-auto'}}">
        <li class="nav-item" (click)="closeNavbar()">
          <a class="nav-link" routerLink="" (click)="onClickInitHome()">{{'label.home'|transloco}}</a>
        </li>

        <li class="nav-item dropdown dropdown-slide">
          <a class="nav-link dropdown-toggle" id="navbarDropdownWebSites" role="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            {{'z-custom.web-sites'|transloco}}
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdownWebSites">
            <li><a class="dropdown-item" routerLink="{{PATH_DESIGN}}" (click)="closeNavbar()" style="text-transform: none;">
                {{'z-custom.web-sites-design-title'|transloco}}
              </a></li>
            <li><a class="dropdown-item" routerLink="{{PATH_FEATURES}}" (click)="closeNavbar()">
                {{'z-custom.web-sites-features'|transloco}}
              </a></li>
            <li><a class="dropdown-item" routerLink="" (click)="onClickPlans()" (click)="closeNavbar()">
                {{'z-custom.prices'|transloco}}
              </a></li>
          </ul>
        </li>

        <li class="nav-item" (click)="closeNavbar()" *ngIf="showServiceType === VIEW_TYPE_PAGE">
          <a class="nav-link" routerLink="{{PATH_SERVICES}}">{{'label.services'|transloco}}</a>
        </li>

        <li class="nav-item" (click)="closeNavbar()" *ngIf="showServiceType === VIEW_TYPE_HOME">
          <a class="nav-link" routerLink="" (click)="onClickServices()">{{'label.services'|transloco}}</a>
        </li>

        <li class="nav-item" (click)="closeNavbar()" *ngIf="showTeamType === VIEW_TYPE_PAGE">
          <a class="nav-link" routerLink="{{PATH_TEAM}}">{{'label.team'|transloco}}</a>
        </li>

        <li class="nav-item" (click)="closeNavbar()" *ngIf="showTeamType === VIEW_TYPE_HOME">
          <a class="nav-link" routerLink="" (click)="onClickTeam()">{{'label.team'|transloco}}</a>
        </li>

        <li class="nav-item" (click)="closeNavbar()" *ngIf="showAboutUsType === VIEW_TYPE_HOME">
          <a class="nav-link" routerLink="" (click)="onClickAboutUs()">{{'label.about-us'|transloco}}</a>
        </li>

        <li class="nav-item" (click)="closeNavbar()" *ngIf="showContactType === VIEW_TYPE_HOME">
          <a class="nav-link" routerLink="" (click)="onClickContact()">{{'label.contact'|transloco}}</a>
        </li>

        <li class="nav-item" (click)="closeNavbar()" *ngIf="showMapType === VIEW_TYPE_HOME">
          <a class="nav-link" routerLink="" (click)="onClickMap()">{{'label.location'|transloco}}</a>
        </li>

        <li class="nav-item" (click)="closeNavbar()" *ngIf="showPublications === VIEW_TYPE_PAGE">
          <a class="nav-link" routerLink="{{PATH_PUBLICATIONS}}">{{'label.publications'|transloco}}</a>
        </li>

        <li class="nav-item" (click)="closeNavbar()" *ngIf="showGallery === VIEW_TYPE_PAGE">
          <a class="nav-link" routerLink="{{PATH_GALLERY}}">{{'label.gallery'|transloco}}</a>
        </li>

        <li class="nav-item" (click)="closeNavbar()" *ngIf="showAboutUsType === VIEW_TYPE_PAGE">
          <a class="nav-link" routerLink="{{PATH_ABOUT}}">{{'label.about-us'|transloco}}</a>
        </li>

        <li class="nav-item" (click)="closeNavbar()" *ngIf="showMapType === VIEW_TYPE_PAGE">
          <a class="nav-link" routerLink="{{PATH_LOCATION}}">{{'label.location'|transloco}}</a>
        </li>

        <li class="nav-item" (click)="closeNavbar()" *ngIf="showContactType === VIEW_TYPE_PAGE">
          <a class="nav-link" routerLink="{{PATH_CONTACT}}">{{'label.contact'|transloco}}</a>
        </li>

        <!-- Pages -->
        <li *ngIf="isBrowser && isMobile" class="nav-item dropdown dropdown-slide">
          <a *ngIf="isBrowser && sessionIsOpen" class="nav-link dropdown-toggle" id="navbarDropdown4" role="button"
            data-delay="350" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{getCustomerName()}}
          </a>
          <a *ngIf="!sessionIsOpen" class="nav-link dropdown-toggle" id="navbarDropdown4" role="button" data-delay="350"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{ 'label.login-invite' | transloco }}
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown4">
            <li *ngIf="sessionIsOpen"><a routerLink="{{PATH_MY_CUSTOMER}}"
                (click)="closeNavbar()">{{'label.profile'|transloco}}</a></li>
            <li *ngIf="sessionIsOpen"><a routerLink="{{PATH_PRODUCT}}" class="btn btn-small btn-transparent"
                (click)="closeNavbar()">{{'label.dashboard'|transloco}}</a></li>
            <li *ngIf="sessionIsOpen && !isProduction"><a routerLink="{{PATH_ADMIN_UI_KIT}}"
                class="btn btn-small btn-transparent" (click)="closeNavbar()">UI Kit</a></li>
            <li *ngIf="sessionIsOpen === false"><a routerLink="{{PATH_LOGIN}}" class="btn btn-small btn-main btn-block"
                (click)="closeNavbar()">{{'login.title'|transloco}}</a></li>
            <li *ngIf="!sessionIsOpen && isProductSite"><a routerLink="{{PATH_REGISTER}}"
                class="btn btn-small btn-main btn-block" (click)="closeNavbar()">{{'register.title'|transloco}}</a></li>
            <li *ngIf="!sessionIsOpen && !isProductSite" class="text-center"><br><small>{{appName}}</small></li>
            <li *ngIf="!sessionIsOpen && !isProductSite"><a href="{{PATH_PRODUCT_SITE}}"
                class="btn btn-small btn-default btn-block" target="_blank">{{'label.know-more'|transloco}}</a></li>
            <li>
              <a href="{{PATH_VERSION}}" class="btn btn-small btn-default btn-block">
                {{'z-custom.web-sites-versions'|transloco}}
              </a>
            </li>
            <li *ngIf="sessionIsOpen"><a (click)="closeSession()"
                class="btn btn-small btn-main btn-block">{{'label.close'|transloco}}</a></li>
          </ul>
        </li><!-- /Pages -->

      </ul>
    </div>
    <!-- Navbar-collapse -->

    <ul class="top-menu list-inline mb-0 d-none d-lg-block" id="top-menu">
      <li class="list-inline-item"><a href="#"></a></li>
      <li class="dropdown cart-nav dropdown-slide list-inline-item">
        <a *ngIf="langBtnType === 'default'" (click)="openLanguageModal()" class="dropdown-toggle cart-icon"
          data-toggle="dropdown" data-hover="dropdown">
          <i class="tf-ion-ios-world mr-3"></i>
        </a>
        <a *ngIf="langBtnType === 'rounded-flag'" (click)="openLanguageModal()"
          class="dropdown-toggle cart-icon rounded-lang-selector" data-toggle="dropdown" data-hover="dropdown">
          <img class="rounded-lang-icon-img" [src]="'assets/img/languages/' + getLangSelected() + '.webp'" alt="Lang">
        </a>
        <a *ngIf="langBtnType === 'rounded-detail-flag'" (click)="openLanguageModal()"
          class="dropdown-toggle cart-icon rounded-dt-lang-selector" data-toggle="dropdown" data-hover="dropdown">
          <img class="rounded-dt-lang-icon-img" [src]="'assets/img/languages/' + getLangSelected() + '.webp'"
            alt="Lang">
          <span class="rounded-dt-lang-code-text">{{ getLangSelected() | uppercase }}</span>
        </a>
        <a *ngIf="langBtnType === 'square-flag'" (click)="openLanguageModal()"
          class="dropdown-toggle cart-icon square-lang-selector" data-toggle="dropdown" data-hover="dropdown">
          <img class="square-lang-icon-img" [src]="'assets/img/languages/' + getLangSelected() + '.webp'" alt="Lang">
        </a>
        <a *ngIf="langBtnType === 'square-detail-flag'" (click)="openLanguageModal()"
          class="dropdown-toggle cart-icon square-dt-lang-selector" data-toggle="dropdown" data-hover="dropdown">
          <img class="square-dt-lang-icon-img" [src]="'assets/img/languages/' + getLangSelected() + '.webp'" alt="Lang">
          <span class="square-dt-lang-code-text">{{ getLangSelected() | uppercase }}</span>
        </a>
      </li>

      <li *ngIf="isBrowser" class="dropdown cart-nav dropdown-slide list-inline-item">
        <a class="dropdown-toggle cart-icon" data-toggle="dropdown" data-hover="dropdown">
          <i class="tf-ion-ios-person mr-3"></i>
        </a>
        <div class="dropdown-menu cart-dropdown">
      <li *ngIf="sessionIsOpen">
        <h3>{{getCustomerName()}}</h3>
      </li>
      <li *ngIf="sessionIsOpen"><a routerLink="{{PATH_MY_CUSTOMER}}">{{'label.profile'|transloco}}</a></li>
      <!--li *ngIf="sessionIsOpen"><a href="user/orders">Orders</a></li>
          <li *ngIf="sessionIsOpen"><a href="user/favorites">My favorites</a></li-->
      <li *ngIf="sessionIsOpen"><a routerLink="{{PATH_PRODUCT}}"
          class="btn btn-small btn-transparent">{{'label.dashboard'|transloco}}</a></li>
      <li *ngIf="sessionIsOpen && !isProduction"><a routerLink="{{PATH_ADMIN_UI_KIT}}"
          class="btn btn-small btn-transparent">UI Kit</a></li>
      <li *ngIf="sessionIsOpen && enableWebmailSiteLink"><a href="{{webmailSite}}" target="_blank"
          class="btn btn-small btn-transparent">{{'label.open-mail-site'|transloco}}</a></li>
      <div *ngIf="sessionIsOpen === false" class="text-center cart-buttons mt-3">
        <a routerLink="{{PATH_LOGIN}}" class="btn btn-small btn-main btn-block">{{'login.title'|transloco}}</a>
      </div>
      <div *ngIf="!sessionIsOpen && isProductSite" class="text-center cart-buttons mt-3">
        <a routerLink="{{PATH_REGISTER}}" class="btn btn-small btn-main btn-block">{{'register.title'|transloco}}</a>
      </div>
      <div *ngIf="!sessionIsOpen && !isProductSite" class="text-center">
        <br><small>{{appName}}</small>
      </div>
      <div *ngIf="!sessionIsOpen && !isProductSite" class="text-center cart-buttons mt-3">
        <a href="{{PATH_PRODUCT_SITE}}" class="btn btn-small btn-default btn-block"
          target="_blank">{{'label.know-more'|transloco}}</a>
      </div>
      <div class="text-center cart-buttons mt-1">
        <a href="{{PATH_VERSION}}" class="btn btn-small btn-default btn-block">
          {{'z-custom.web-sites-versions'|transloco}}
        </a>
      </div>
      <div *ngIf="sessionIsOpen" class="text-center cart-buttons mt-3">
        <a (click)="closeSession()" class="btn btn-small btn-main btn-block">{{'label.close'|transloco}}</a>
      </div>
  </div>
  </li>
  </ul>
  </div>
</nav>
